module.exports = __webpack_public_path__ + "img/logo-mini.60356aa0.svg";